<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="float-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="submit">
            Save
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <div class="card-body-overlay" v-if="!Object.keys(client).length">
          Please complete the "Client Details" section before the clients
          vehicle.
        </div>

        <div class="row">
          <div class="col-lg-6">
            <selectlist
              :options="licenseTypes"
              v-model="form.license_type"
              label="License Type"
              name="license_type"
              placeholder="Please Select"
              :show-error="form.errors.has('license_type')"
              key-name="type"
              label-name="type"
            ></selectlist>

            <toggleswitch
              :labels="true"
              name="own_the_vehicle"
              label="own the vehicle"
              v-model="form.own_the_vehicle"
              helper="Do you own the vehicle?"
            ></toggleswitch>

            <toggleswitch
              :labels="true"
              name="v5_in_your_name"
              label="V5"
              v-model="form.v5_in_your_name"
              helper="Is the V5 in your name?"
            ></toggleswitch>

            <inputbox
              v-if="!form.v5_in_your_name"
              v-model="form.v5_owner_name"
              name="v5_owner_name"
              label="V5 owner Name"
              helper="Please enter the name of the V5 owner."
            ></inputbox>
          </div>

          <div class="col-lg-6">
            <toggleswitch
              :labels="true"
              name="have_cbt"
              label="CBT"
              v-model="form.have_cbt"
              helper="Do you have a CBT?"
            ></toggleswitch>

            <div v-if="form.have_cbt" class="form-group">
              <div class="col-md-4">
                <label class="control-label">CBT Expiry:</label>
                <p class="help-block">Please enter the date the CBT expires</p>
              </div>
              <div class="col-lg-8">
                <datepicker
                  format="dd/MM/yyyy"
                  v-bind:value="form.cbt_expires_at"
                  name="cbt_expires_at"
                  input-class="form-control"
                  v-on:selected="setCBTExpiry"
                  v-on:input="changeHandler"
                  placeholder="dd/mm/yyyy"
                ></datepicker>
                <span
                  class="text-danger"
                  v-text="form.errors.get('cbt_expires_at')"
                  v-if="form.errors.has('cbt_expires_at')"
                ></span>
              </div>
            </div>

            <toggleswitch
              :labels="true"
              name="provide_license_share_code"
              label="License Share Code"
              v-model="form.provide_license_share_code"
              helper="Can you provide a License Share Code?"
            ></toggleswitch>

            <inputbox
              v-model="form.license_share_code"
              :show-error="form.errors.has('license_share_code')"
              v-if="form.provide_license_share_code"
              name="license_share_code"
              label="License Share Code"
              helper="License Share Code"
            ></inputbox>

            <inputbox
              v-model="form.license_number"
              :show-error="form.errors.has('license_number')"
              v-if="form.provide_license_share_code"
              name="license_number"
              label="License Number"
              helper="License Number"
            ></inputbox>
          </div>

          <div class="col-lg-12">
            <toggleswitch
              :labels="true"
              name="claiming_comp"
              label="Claiming Comp"
              v-model="form.claiming_comp"
              helper="Is the client claiming compensation?"
            ></toggleswitch>
          </div>
        </div>
      </div>
      <div class="card-footer text-right" v-if="!readonly">
        <form-button :indicator="form.processing()" v-on:clicked="submit">
          Save
        </form-button>
      </div>
    </fieldset>
  </form>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: new window.Form({
        license_type: null,
        have_cbt: false,
        own_the_vehicle: false,
        v5_in_your_name: false,
        v5_owner_name: null,
        provide_license_share_code: false,
        license_share_code: null,
        license_number: null,
        cbt_expires_at: null,
        claiming_comp: null
      }),
      data_entered: false,
      licenseTypes: [
        {
          type: 'Full Car / Full Bike'
        },
        {
          type: 'Full Car / Full Restricted Bike'
        },
        {
          type: 'Full Car / CBT'
        },
        {
          type: 'Full Car'
        },
        {
          type: 'Provisional Car / CBT'
        },
        {
          type: 'Provisional Car / Full Bike'
        },
        {
          type: 'Provisional Car / Full Bike Restricted'
        },
        {
          type: 'Provisional Car'
        }
      ]
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    client() {
      return this.$store.getters['Incident/client'];
    }
  },

  methods: {
    mount() {
      if (Object.keys(this.client).length && this.client.indemnity) {
        this.form.license_type = this.client.indemnity.license_type;
        this.form.have_cbt = this.client.indemnity.have_cbt;
        this.form.own_the_vehicle = this.client.indemnity.own_the_vehicle;
        this.form.v5_in_your_name = this.client.indemnity.v5_in_your_name;
        this.form.v5_owner_name = this.client.indemnity.v5_owner_name;
        this.form.provide_license_share_code = this.client.indemnity.provide_license_share_code;
        this.form.license_share_code = this.client.indemnity.license_share_code;
        this.form.license_number = this.client.indemnity.license_number;
        this.form.cbt_expires_at = this.client.indemnity.cbt_expires_at;
        this.form.claiming_comp = this.client.indemnity.claiming_comp;
      }
    },

    /**
     * If the user tries to change tab when there are unsaved changes in the form we
     * want to display a popup warning them they have unsaved changes.
     *
     * To do that we add a form @change event listener to the form and then emit an
     * 'unsaved-data' event whenever a form value changes. This is then picked up
     * in the parent component and that handles displaying the warning if the user
     * tries to change tabs.
     */
    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      if (this.readonly) return;
      window.toastify.info('Saving', "We're saving those details for you.");

      this.form
        .post(
          `/incidents/${this.incident}/client/${this.client.identifier}/indemnity`
        )
        .then(response => {
          window.toastify.success(
            'Saved',
            "We've updated those details for you."
          );
          // reset monitoring of form changes
          this.data_entered = false;
          this.$emit('unsaved-data', this.data_entered);
          this.$store.commit('Incident/setClientIndemnity', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the indemnity details.'
          );
        });
    },
    setCBTExpiry(value) {
      this.form.cbt_expires_at = value;
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
